import moment from 'moment/moment';

export class Constants {
    static readonly STATUS = {
        pending: 'pending',
        in_progress: 'inProgress',
        success: 'success',
        no_data: 'noData',
        failure: 'failure',
    };

    static readonly BASE_API_URL = 'https://api.dataprovisioning-euda.rio.cloud';

    static readonly ASSET_ADMIN_URL = `https://administration.assets.rio.cloud/#/assets`;

    static readonly HISTORICAL_TABLE_HEADERS = ['createDate', 'startDate', 'endDate', 'vehicles', 'status', 'paths'];

    static readonly INITIAL_VALID_DATE = moment('2025-09-12');

    static readonly DATE_ERROR_TYPE = {
        invalidStartDate: 'invalidStartDate',
        invalidDateRange: 'invalidDateRange',
        invalidDateFuture: 'invalidDateFuture',
    };

    static readonly DEFAULT_COLUMN_ORDER = ['name', 'identification'];

    static readonly COLUMN_LABELS = {
        name: 'Name',
        identification: 'VIN',
        manufacturer: 'Manufacturer',
    };

    static readonly HTTP_ERROR_MAPPINGS = {
        400: 'Something went wrong, please contact support.',
        401: 'Something went wrong, please contact support.',
        403: 'Something went wrong, please contact support.',
        404: 'Something went wrong, please contact support.',
        409: 'A request is currently being processed. Your information has not been submitted. Please wait for the current request to complete before trying again',
        500: 'Something went wrong, please contact support.',
    };

    static readonly LINK_VALIDITY_DAYS = 14;
}
